import React from 'react';
import './matchOutfitSection.scss';
import CircleSvg from "../../../../components/images/CircleSvg";
import {useTranslation} from "react-i18next";

const MatchOutfitSection = () => {
	const { t } = useTranslation();
	const options = ['sport', 'work', 'mama', 'play', 'hairExtension', 'sleep'];

	return (
		<div className="matchOutfit">
			<div className={`main__bg_animations_item c6`} />
			<div className={`main__bg_animations_item c7`} />
			<div className={`main__bg_animations_item c8`} />
			<div className="matchOutfit__content">
				<div className="matchOutfit__content_header">
					<h3>{t('matchOutfit.title1')}<br/>{t('matchOutfit.title2')}</h3>
				</div>
				<div className="matchOutfit__content_items">

					{options.map((option: string, index: number) => (
						<div
							key={option}
							className="matchOutfit__content_items_element"
						>
							<span>{t(`matchOutfit.options.${option}`)}</span>
							{index < options.length - 1 && <CircleSvg color={'#F37021'} />}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default MatchOutfitSection;